export enum SignerTypes {
  CONTACT = 'CONTACT',
  MEMBER = 'MEMBER',
  CUSTOM = 'CUSTOM',
}
